import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import "./Choosing.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import Carousel from "../../../../../components/Carousel";
import { Item } from "../../../../../components/Carousel/styles";

import voiceServices from "../../../../../redux/services/categories/voice/programs";
import muzakrServices from "../../../../../redux/services/categories/muzakr/programs";
const MuzakrChooseGame = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const [nextBack, setNextBack] = useState({
    next: null,
    back: null,
  });
  const [images, setImages] = useState({
    right: null,
    wrong: null,
  });

  const [sound, setSound] = useState({
    choose: null,
    right: null,
    wrong: null,
  });
  useEffect(() => {
    muzakrServices.choose("muzakarchoose", id).then((res) => {
      setSound({
        // choose: `https://maharttafl.com/sound/${res.data.sound.choose}`,
        item: `https://maharttafl.com/sound/${res.data.opposites.sound}`,
        // right: `https://maharttafl.com/sound/${res.data.sound.right}`,
        // wrong: `https://maharttafl.com/sound/${res.data.sound.wrong}`,
      });
      // //console.log(res.data);
      // setImages({
      //   right:res.data.opposites.right,
      //   wrong:res.data.opposites.wrong,
      // })
      setImages(res.data.opposites.images);
      setNextBack({ ...nextBack, next: res.data.next });
      setNextBack({ ...nextBack, back: res.data.previous });
      setIsLoading(false);
    });
  }, []);
  // const chooseAudio = async () => {
  //   let audio = new Audio(sound.choose);
  //   await audio.play();
  // };
  const chooseAudioItem = async () => {
    let audio2 = new Audio(sound.item);
    audio2.play();
  };
  const wrong = () => {
    let audio = new Audio(`https://maharttafl.com/sound/horn.mp3`);
    audio.play();
  };
  const clapp = () => {
    let audio = new Audio(`https://maharttafl.com/sound/clapp.mp3`);
    audio.play();
  };
  if (isLoading) return <></>;

  return (
    <div className="games__page">
      <div>
        <button
          style={{ width: "100%" }}
          onClick={() => {
            chooseAudioItem();
            // chooseAudio();
            // setTimeout(() => {
            // }, 1300);
          }}
        >
          Listen
        </button>
        <Carousel className="games__section container" keys={false}>
          {images.map((t, index) => {
            return (
              <Item key={index}>
                <img
                  src={`https://maharttafl.com/images/${t.image}`}
                  alt=""
                  style={{
                    width: "150px",
                    height: "150px",
                    border: "1px solid #dedede",
                    borderRadius: "30%",
                  }}
                  onClick={() => {
                    if (t.type === "wrong") {
                      wrong();
                      // setTimeout(() => {
                      //   let audio = new Audio(sound.wrong);
                      //   audio.play();
                      // }, 2500);
                    }
                    if (t.type === "right") {
                      clapp();
                      // setTimeout(() => {
                      //   let audio = new Audio(sound.right);
                      //   audio.play();
                      // }, 2500);
                    }
                  }}
                />
              </Item>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default MuzakrChooseGame;
